import { BASE_URL } from '../utils/apiUtils';
import { HttpService } from './HttpService';

export const merchantServices = () => {
	const { get } = HttpService();

	const getMerchants = async (page, size, merchantName) => {
		return get(
			`${BASE_URL}/api/merchants?page=${page}&size=${size}&search=${merchantName}`,
			'getCasesByCaseNumber',
			{}
		);
	};
	return {
		getMerchants
	};
};
